export const BUILDER_PREVIEW_FONT_CUSTOM_PROPERTIES = [
  "--font-barlow-condensed",
  "--font-inter",
  "--font-manrope",
  "--font-space-grotesk",
  "--font-sora",
  "--font-cormorant",
  "--font-roboto-slab",
  "--font-eb-garamond",
] as const;

type FontStyleReader = Pick<CSSStyleDeclaration, "getPropertyValue">;
type FontStyleWriter = Pick<CSSStyleDeclaration, "removeProperty" | "setProperty">;

export function copyBuilderPreviewFontCustomProperties(
  sourceElement: Element,
  targetElement: { style: FontStyleWriter },
  resolveStyle: (element: Element) => FontStyleReader = getComputedStyle,
): void {
  const sourceStyle = resolveStyle(sourceElement);

  for (const property of BUILDER_PREVIEW_FONT_CUSTOM_PROPERTIES) {
    const value = sourceStyle.getPropertyValue(property).trim();

    if (value === "") {
      targetElement.style.removeProperty(property);
      continue;
    }

    targetElement.style.setProperty(property, value);
  }
}
